import script from "./moresubjects.vue?vue&type=script&setup=true&lang=js"
export * from "./moresubjects.vue?vue&type=script&setup=true&lang=js"

import "./moresubjects.vue?vue&type=style&index=0&id=3aafc18a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aafc18a"]])

export default __exports__